export default __webpack_public_path__ + "static/media/prj_1.fee77816.png";